import React from "react";
import styled, { keyframes } from "styled-components";

export const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Container = styled.div`
    margin-top:10px;
    display: flex;
    justify-content: center;
    height: 100vh;
    font-family: "Segoe UI", Arial, sans-serif;
`;

export const MessageBox = styled.div`
  background: #fff;
  padding: 2rem 2rem;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 480px;
  max-height: 420px;
  animation: ${fadeIn} 0.6s ease;
`;

export const Icon = styled.div`
    font-size: 48px;
    margin-bottom: 0.5rem;
`;

export const Title = styled.h2`
    color: #333;
    margin-bottom: 0.8rem;
`;

export const Text = styled.p`
    color: #555;
    line-height: 1.5;
`;



export const HrefButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;

  background-color: #cb0c9f; /* équivalent Bootstrap btn-primary */
  color: white;
  padding: 0.5rem 0.8rem;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.9rem;
  text-decoration: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease-in-out;

  &:hover {
   color:#fff;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);
  }

  svg {
    font-size: 1.2rem;
  }
`;
